import _defineProperty from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.find.js";

/* eslint-disable camelcase */

/* eslint-disable no-shadow */
import Vue from 'vue';
import Vuex from 'vuex';
import atom from '@tencent/vft-atom';
import config from '@/config';
Vue.use(Vuex);
var _window$setting = window.setting,
    _window$setting$魔方 = _window$setting.魔方,
    云积分读取 = _window$setting$魔方.云积分读取,
    actId = _window$setting$魔方.活动ID,
    套餐模块 = _window$setting.开通套餐模块.套餐模块;
var state = {
  remainNum: {},
  // 抽奖次数
  propertyCount: 0,
  // 奖品数量
  boostList: [],
  // 助力用户列表
  boostedList: [],
  // 被助力用户列表
  shareStatus: false,
  // 用户是否已经完成助力
  nbaVip: 0,
  // nba 会员标示，0 非会员，1 普通会员，2 超级会员
  nbaVipIcon: '',
  // nba 角标
  openStatus: {} // 当前场景[ott、app]四套餐的开通状态

};
var mutations = {
  setState: function setState(state, payload) {
    state[payload.state] = payload.value;
  }
};
var actions = {
  getLotteryCount: function getLotteryCount(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, 模块ID, 积分ID, _yield$Vue$prototype$, scores, remainNum, _window$$aegis;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.prev = 1;
              模块ID = 云积分读取.模块ID, 积分ID = 云积分读取.积分ID;
              _context.next = 5;
              return Vue.prototype.magicService.getScore({
                module_id: 模块ID
              });

            case 5:
              _yield$Vue$prototype$ = _context.sent;
              scores = _yield$Vue$prototype$.scores;
              remainNum = {};
              Object.keys(积分ID).forEach(function (key) {
                var scoreId = 积分ID[key];
                var score = scores[scoreId].score;
                remainNum[key] = score;
              });
              commit('setState', {
                state: 'remainNum',
                value: remainNum
              });
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              (_window$$aegis = window.$aegis) === null || _window$$aegis === void 0 ? void 0 : _window$$aegis.reportEvent('[getLotteryCount error]', _context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }))();
  },
  // 获取已助力的用户列表
  getAssistList: function getAssistList(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, getters, assistInfo, _ref3, _ref3$share_message, boostList, remainShareNums, list;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit, getters = _ref2.getters;
              _context2.prev = 1;
              _context2.next = 4;
              return Vue.prototype.magicService.getAssistList(getters.assistModId);

            case 4:
              assistInfo = _context2.sent;
              // eslint-disable-next-line camelcase
              _ref3 = assistInfo || {}, _ref3$share_message = _ref3.share_message;
              _ref3$share_message = _ref3$share_message === void 0 ? {} : _ref3$share_message;
              boostList = _ref3$share_message.share_list, remainShareNums = _ref3$share_message.remain_share_nums;
              list = boostList || [];
              commit('setState', {
                state: 'boostList',
                value: list
              });
              commit('setState', {
                state: 'shareStatus',
                value: remainShareNums === 0
              });
              _context2.next = 16;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](1);
              Vue.prototype.toast("".concat(_context2.t0.msg || _context2.t0.message, "\u3010").concat(_context2.t0.code, "\u3011"));

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 13]]);
    }))();
  },
  // 获取被助力的用户列表
  getBeAssistList: function getBeAssistList(_ref4) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, getters, assistInfo, _ref5, boostedList;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref4.commit, getters = _ref4.getters;
              _context3.next = 3;
              return Vue.prototype.magicService.getBeAssistList(getters.assistModId)["catch"](function (e) {
                _this.toast("".concat(e.msg || e.message, "\u3010").concat(e.code, "\u3011"));

                return Promise.reject(e);
              });

            case 3:
              assistInfo = _context3.sent;
              // eslint-disable-next-line camelcase
              _ref5 = assistInfo || {}, boostedList = _ref5.visit_data;
              commit('setState', {
                state: 'boostedList',
                value: boostedList || []
              });

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  // 查询用户 vip 信息
  getSportVip: function getSportVip(_ref6) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, payVip, _payVip$nba, _payVip$nba$vip, vip, nbaVipIcon, _payVip$nba$svip, svip, nbaSvipIcon, type, icon;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref6.commit;
              _context4.next = 3;
              return atom.getPayVip({
                viptype: ['nba']
              });

            case 3:
              payVip = _context4.sent;

              if (payVip) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return");

            case 6:
              _payVip$nba = payVip.nba, _payVip$nba$vip = _payVip$nba.vip, vip = _payVip$nba$vip.vip, nbaVipIcon = _payVip$nba$vip.icon_url, _payVip$nba$svip = _payVip$nba.svip, svip = _payVip$nba$svip.vip, nbaSvipIcon = _payVip$nba$svip.icon_url;
              type = 0;
              icon = '';

              if (vip === 1 && svip === 1) {
                type = 2;
                icon = nbaSvipIcon;
              } else if (vip === 1 && svip === 0) {
                type = 1;
                icon = nbaVipIcon;
              } else {
                type = 0;
              }

              commit('setState', {
                state: 'nbaVip',
                value: type
              });
              commit('setState', {
                state: 'nbaVipIcon',
                value: icon
              });

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  // 查询套餐开通状态
  getOpenState: function getOpenState(_ref7) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _ref8;

      var commit, mods, modList, batchArr, actRes, status;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref7.commit;
              mods = 套餐模块[config.fromtv ? 'tv' : 'app'];
              /**
                {
                  "vip":{
                      "连续包月":{
                          "模块id":"g7o233yg2xy5ipx7aryrxujq39",
                          "跳转链接":"https://m.film.qq.com/sports/unipay/index.html?actid=THTY_8752&tab=vip&fh5=1"
                      },
                      "季卡":{
                          "模块id":"g4ow3d39xc8z21pi6l7rc3gyt9",
                          "跳转链接":"https://m.film.qq.com/sports/unipay/index.html?actid=THTY_8756&tab=vip&fh5=1"
                      }
                  },
                  "svip":{
                      "连续包月":{
                          "模块id":"jqgclx5sxshhg1shzr06paq8o5",
                          "跳转链接":"https://m.film.qq.com/sports/unipay/index.html?actid=TSTY_8708&tab=svip&fh5=1"
                      },
                      "季卡":{
                          "模块id":"c5za8suwj2q7t6aqqcxsxuzc4g",
                          "跳转链接":"https://m.film.qq.com/sports/unipay/index.html?actid=TSTY_8758&tab=svip&fh5=1"
                      }
                  }
              }
               */
              // 二维数组打散成一维数组

              modList = (_ref8 = []).concat.apply(_ref8, _toConsumableArray(Object.values(mods).map(function (v) {
                return Object.values(v);
              })));
              batchArr = modList.map(function (mod) {
                return {
                  unique_id: mod.模块id,
                  type: 7,
                  option: 3,
                  act_id: actId,
                  module_id: mod.模块id
                };
              });
              _context5.next = 6;
              return Vue.prototype.magicService.batchCgi(_toConsumableArray(batchArr));

            case 6:
              actRes = _context5.sent;
              // 取指定数据
              status = Object.keys(actRes).map(function (key) {
                var _actRes$key;

                return {
                  key: key,
                  status: ((_actRes$key = actRes[key]) === null || _actRes$key === void 0 ? void 0 : _actRes$key.ret) === 0
                };
              }).reduce(function (total, cur) {
                return _objectSpread(_objectSpread({}, total), {}, _defineProperty({}, cur.key, cur.status));
              }, {});
              commit('setState', {
                state: 'openStatus',
                value: status
              });

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
};
var getters = {
  // 当前阶段的分享助力魔方id
  assistModId: function assistModId() {
    var nowTime = Date.now();
    var curItem = window.setting.魔方.分享助力.find(function (v) {
      return nowTime >= v.开始时间 && nowTime <= v.结束时间;
    });
    return (curItem === null || curItem === void 0 ? void 0 : curItem.模块ID) || null;
  }
};
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});